var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LoadingSpinner',{attrs:{"isLoading":true}}),_c('MStoreTimeout',{attrs:{"timeoutSeconds":_vm.SIGN_OUT_TIMEOUT_DURATION_IN_SECONDS,"action":_vm.signout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }